import { plexTranslationMessagesManager } from "./PlexTranslationMessages.slice";

export const plexTranslationMessagesActions = { ...plexTranslationMessagesManager.actions };
